import React, { FC, useState, useRef, useEffect } from 'react';
import cls from 'classnames';

import { StickyBoxBottomProps } from './StickyBoxBottom.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';

/* This component determines the height of its children,
		and sets the height of the outermost container to that height to ensure that
		other content is able to scroll past the "fixed" content
*/

export const classNames = getClassNames('sds-stickyBoxBottom', [
	'fade',
	'inner',
	'solid-background',
	'legal-layout',
	'button'
]);

const StickyBoxBottom: FC<StickyBoxBottomProps>  = (props) => {
	const {
		className,
		legalLayout,
		buttonLayout,
		bottom=0,
		background = 'background',
	} = props;
	const containerRef = useRef<HTMLDivElement>(null);
	const [height, setHeight] = useState(0);

	useEffect(() => {
		if (!containerRef?.current?.clientHeight) {
			return;
		}
		setHeight(containerRef?.current?.clientHeight);
	}, [containerRef?.current?.clientHeight]);
	return (
		<div className={cls(getRootClassListFromProps(classNames, props), className)} style={{ height }}>
			
			<div
				className={classNames.inner}
				style={{ bottom }}
				ref={containerRef}
			>
				<div className={cls(classNames.fade)} style={{background:`linear-gradient(0deg,rgb(var(--${background})) 0%,transparent 100%)`}}></div>	
				<div className={cls(classNames.solidBackground,`bg-${background}`)}>
					{legalLayout && <div className={classNames.legalLayout}>{legalLayout}</div>}
					<div className={classNames.button}>{buttonLayout}</div>
				</div>
			</div>
		</div>
	);
};

StickyBoxBottom.displayName = 'StickyBoxBottom';

export default StickyBoxBottom;
